export default __webpack_public_path__ + "static/media/sms_slide11.c64e486e.jpg";